import { Component, Input } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'boma-anim-spinning-loader',
  templateUrl: './boma-spinning-loader.component.html',
  styleUrls: ['./boma-spinning-loader.component.scss'],
})
export class BomaSpinningLoaderComponent {
  @Input() size = 150;
  @Input() style = '';
  options: AnimationOptions = {
    path: '/assets/lottie/boma-loader.json',
  };

  constructor() {}
}
